import {Component, HostListener} from '@angular/core';
import {SpecialStyle} from './special-style';
import {NotifyingCartaFeatureList} from './areas';
import {environment} from '../environments/environment';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  public areas = new NotifyingCartaFeatureList();
  public style = new SpecialStyle();
  public enableGeojson = false;

  constructor(private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
      const geojson = params['geojson'];
      this.enableGeojson = geojson === 'true' || geojson === '1';
    });
  }

  @HostListener('window:message', ['$event'])
  public handleMessage(event: MessageEvent) {
    // Do not react for events from the webpage itself
    if (event.origin.match(environment.aymoMapUrlRegex)) {
      return;
    }

    // TODO: add a check for aymo website url
    // if (event.origin !== environment.aymoMessageOrigin && environment.environmentFile === 'prod') {
    //   return;
    // }

    this.areas.setPostMessageDestination(event.source, event.origin);
  }
}
